<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="formTaskCommit" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24" v-if="operation.type !== SysFlowTaskOperationType.CO_SIGN && operation.type !== SysFlowTaskOperationType.MULTI_SIGN && !operation.flag">
          <el-form-item v-if="needSign" label="签字确认：" prop="message">
            <el-button v-if="!signDialogVisible" type="primary" size="small" @click="signDialogVisible = true">签名</el-button>
            <sign-pad ref="sign" v-else @confirm="onSignConfirm" />
          </el-form-item>
          <el-form-item v-else-if="needSignT" label="签字确认：" prop="message">
            <img style="width: 200px" :src="src" alt="">
          </el-form-item>
          <el-form-item v-else label="审批意见：" prop="message">
            <el-input type="textarea" :rows="4" :disabled="formData.message === '提交'" v-model="formData.message" clearable placeholder="请输入审批意见" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showAssignSelect">
          <el-form-item label="指派用户：" prop="assignee">
            <TagSelect v-model="formData.assignee">
              <el-button slot="append" class="append-add" type="default" icon="el-icon-plus" @click="onSelectAssignee" />
            </TagSelect>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" @click="onSubmitClick()">
              提交
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import TagSelect from '@/views/workflow/components/TagSelect.vue';
import TaskUserSelect from '@/views/workflow/components/TaskUserSelect.vue';
import SignPad from '@/views/workflow/components/SignPad.vue';

export default {
  name: 'formTaskCommit',
  props: {
    operation: {
      type: Object,
      required: true
    }
  },
  components: {
    TagSelect,
    SignPad
  },
  data () {
    return {
      formData: {
        message: this.operation.label,
        assignee: undefined
      },
      signDialogVisible: false,
      rules: {
        message: [{required: true, message: '审批意见不能为空', trigger: 'blur'}],
        assignee: [{required: true, message: '指派用户不能为空', trigger: 'blur'}]
      },
      src: 'https://rongfanjs.com/田总签名.png'
    }
  },
  created () {
    const info = JSON.parse(localStorage.getItem('userInfo')).data
    const route = this.$route
    if (info.deptName === '合同管理部' && this.operation.label === '同意' && (route.query.formId === '2074057795207958528' || route.query.formId === '2074075327247683584' || route.query.formId === '2074073417283276800')) {
      this.formData.message = '已做初步审查，资料、模板合规，提请后续领导复审'
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onSubmitClick () {
      this.$refs.formTaskCommit.validate(valid => {
        if (!valid) return;
        if (this.needSign) {
          // 判断是否已签名
          if (this.$refs.sign && this.$refs.sign.isEmpty()) {
            this.$message.warning('请签名')
            return
          }
          this.$refs.sign.onConfirm()
        }
        if (this.needSignT) {
          this.formData.message = this.src
        }
        this.onCancel(true, this.formData);
      });
    },
    onSignConfirm (base64) {
      this.formData.message = base64
    },
    base64ToBlob (base64) {
      const parts = base64.split(',')
      const mime = parts[0].match(/:(.*?);/)[1]
      const bstr = atob(parts[1])
      const n = bstr.length
      const u8arr = new Uint8Array(n)
      for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i)
      }
      return new Blob([u8arr], { type: mime })
    },
    onSelectAssignee () {
      this.$dialog.show('选择用户', TaskUserSelect, {
        area: ['1000px', '600px']
      }, {
        showAssignee: false,
        multiple: this.multiSelect
      }).then(res => {
        let assignee = null;
        if (Array.isArray(res)) {
          assignee = res.map(item => item.loginName).join(',');
        } else {
          assignee = (res || {}).loginName;
        }
        this.formData.assignee = assignee;
      }).catch(e => {});
    }
  },
  computed: {
    showAssignSelect () {
      let showAssignSelect = false;
      // 如果是会签操作，判断是否在流程内设置了会签人
      if (this.operation.type === this.SysFlowTaskOperationType.MULTI_SIGN) {
        showAssignSelect = !this.operation.multiSignAssignee ||
          !Array.isArray(this.operation.multiSignAssignee.assigneeList) ||
          this.operation.multiSignAssignee.assigneeList.length <= 0;
      }
      return [
        this.SysFlowTaskOperationType.TRANSFER,
        this.SysFlowTaskOperationType.CO_SIGN,
        this.SysFlowTaskOperationType.SET_ASSIGNEE
      ].indexOf(this.operation.type) !== -1 || showAssignSelect;
    },
    multiSelect () {
      return this.operation.type === this.SysFlowTaskOperationType.CO_SIGN || this.operation.type === this.SysFlowTaskOperationType.MULTI_SIGN;
    },
    needSign () {
      const info = JSON.parse(localStorage.getItem('userInfo')).data
      const route = this.$route
      return (info.showName === '张磊' || info.showName === '华锐') && this.operation.label === '同意' &&  (route.query.formId === '2074057795207958528' || route.query.formId === '2074075327247683584' || route.query.formId === '2074073417283276800')
    },
    needSignT () {
      const info = JSON.parse(localStorage.getItem('userInfo')).data
      const route = this.$route
      return (info.showName === '田琳') && this.operation.label === '同意' &&  (route.query.formId === '2074057795207958528' || route.query.formId === '2074075327247683584' || route.query.formId === '2074073417283276800')
    }
  }
}
</script>

<style scoped>
  .append-add {
    border: none;
    border-left: 1px solid #DCDFE6;
    border-radius: 0px;
    background: #F5F7FA;
  }
</style>
